import {
  getAlternateContactFieldRequestBody,
  getPhoneFieldRequestBody,
} from '../../dynamicForm/helper/apiHelpers';
import { ConfirmationTypes } from '../ConfirmationTypes';

export const dateFormatter = (dateField: any) => {
  const date = new Date(dateField);
  // Format the date to "YYYY-MM-DD"
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const frameRequestForCreateTenant = (res: any) => {
  const {
    TenantInfo_FirstName,
    TenantInfo_LastName,
    TenantInfo_AddressLine1,
    TenantInfo_AddressLine2,
    TenantInfo_City,
    TenantInfo_StateProvince,
    TenantInfo_PostalCode,
    TenantInfo_CellPhone,
    TenantInfo_HomePhone,
    TenantInfo_EmailAddress,
    TenantInfo_BirthDate,
    TenantInfo_DriverLicenseNumber,
    TenantInfo_DriversLicenseExpirationDate,
    OtherInfo_MilitaryBranch,
    OtherInfo_MilitaryCOPhone,
    OtherInfo_MilitaryCommandingOfficer,
    OtherInfo_MilitaryDeployedUntilDate,
    OtherInfo_MilitaryDivisionUnit,
    OtherInfo_MilitaryID,
    OtherInfo_MilitaryType,
    AlternateInfo_FirstName,
    AlternateInfo_LastName,
    AlternateInfo_AddressLine1,
    AlternateInfo_AddressLine2,
    AlternateInfo_City,
    AlternateInfo_StateProvince,
    AlternateInfo_PostalCode,
    AlternateInfo_PhoneNumber,
    AlternateInfo_EmailAddress,
    AlternateInfo_Relationship,
    AlternateInfo_HomeNumber,
    TenantInfo_SSN,
    TenantInfo_StateId,
  } = res;

  const getPhoneNumberList = () => {
    let phoneNumberList = [];

    TenantInfo_CellPhone &&
      phoneNumberList.push(
        getPhoneFieldRequestBody(
          TenantInfo_CellPhone.slice(0, 3),
          TenantInfo_CellPhone.slice(3, TenantInfo_CellPhone.length),
          '1',
          'us',
          'Create',
          'Cell_Phone'
        )
      );
    TenantInfo_HomePhone &&
      phoneNumberList.push(
        getPhoneFieldRequestBody(
          TenantInfo_HomePhone.slice(0, 3),
          TenantInfo_HomePhone.slice(3, TenantInfo_HomePhone.length),
          '1',
          'us',
          'Create',
          'Home_Phone'
        )
      );

    return phoneNumberList.length !== 0 ? phoneNumberList : undefined;
  };

  const req: any = {
    name: {
      last_name: TenantInfo_LastName,
      first_name: TenantInfo_FirstName,
    },
    address: {
      line1: TenantInfo_AddressLine1,
      line2: TenantInfo_AddressLine2,
      city: TenantInfo_City,
      state: TenantInfo_StateProvince,
      zip_code: parseInt(TenantInfo_PostalCode, 10),
    },
    phone: {
      text_enabled_cell_number:
        TenantInfo_CellPhone && `1${TenantInfo_CellPhone}`,
      primary_number: TenantInfo_CellPhone && `1${TenantInfo_CellPhone}`,
      phone_number_list: getPhoneNumberList(),
    },
    email: {
      email_address: TenantInfo_EmailAddress,
      is_email_enabled: !!TenantInfo_EmailAddress,
    },
    dob: TenantInfo_BirthDate,
    id_proof: {
      driver_license: TenantInfo_DriverLicenseNumber,
      license_expiration: TenantInfo_DriversLicenseExpirationDate,
      state_id: TenantInfo_StateId,
      ssn: TenantInfo_SSN,
    },
    military_info: {
      military_id: OtherInfo_MilitaryID,
      type: OtherInfo_MilitaryType,
      branch: OtherInfo_MilitaryBranch,
      deployed_until: OtherInfo_MilitaryDeployedUntilDate,
      division: OtherInfo_MilitaryDivisionUnit,
      commanding_officer: OtherInfo_MilitaryCommandingOfficer,
      commanding_officer_phone: OtherInfo_MilitaryCOPhone
        ? getAlternateContactFieldRequestBody(
            OtherInfo_MilitaryCOPhone.slice(0, 3),
            OtherInfo_MilitaryCOPhone.slice(
              3,
              OtherInfo_MilitaryCOPhone.length
            ),
            '1',
            'us'
          )
        : undefined,
    },
    other_address: {
      alternate_contact: {
        name: {
          first_name: AlternateInfo_FirstName,
          last_name: AlternateInfo_LastName,
        },
        address: {
          line1: AlternateInfo_AddressLine1,
          line2: AlternateInfo_AddressLine2,
          city: AlternateInfo_City,
          state: AlternateInfo_StateProvince,
          zip_code: parseInt(AlternateInfo_PostalCode, 10),
        },
        phone: {
          cell_phone: AlternateInfo_PhoneNumber
            ? getAlternateContactFieldRequestBody(
                AlternateInfo_PhoneNumber.slice(0, 3),
                AlternateInfo_PhoneNumber.slice(
                  3,
                  AlternateInfo_PhoneNumber.length
                ),
                '1',
                'us'
              )
            : undefined,
          home_phone: AlternateInfo_HomeNumber
            ? getAlternateContactFieldRequestBody(
                AlternateInfo_HomeNumber.slice(0, 3),
                AlternateInfo_HomeNumber.slice(
                  3,
                  AlternateInfo_HomeNumber.length
                ),
                '1',
                'us'
              )
            : undefined,
        },
        email: AlternateInfo_EmailAddress,
        relation: AlternateInfo_Relationship,
      },
    },
    ledger: [
      {
        label: 'Primary',
      },
    ],
  };

  const removeEmpty = (req: ConfirmationTypes.TConfirmationRequest) => {
    Object.keys(req).forEach(function(key) {
      let value = req[key];
      let type = typeof value;
      if (type === 'object') {
        removeEmpty(value);
        if (!Object.keys(value).length) {
          delete req[key];
        }
      } else if (
        type === 'undefined' ||
        (type === 'number' && isNaN(value)) ||
        value === null
      ) {
        delete req[key];
      }
    });
    return req;
  };
  return removeEmpty(req);
};

export const frameRentalInfoResForPayment = (
  { rental_info, charges }: any,
  moveInDate: string,
  gatsbyPathName: string,
  unit_type_id: string | number,
  ledgerIdFromSMS: string,
  reservationId?: string,
  promoPlanData?: any
) => {
  const source = gatsbyPathName.includes('move-in') ? 'Move_In' : 'Reservation';
  const MoveInDate = moveInDate
    ? moveInDate
    : getMoveInDateForMoveInForm(new Date());
  const {
    default_tenant_deposit,
    default_unit_rate,
    prorate: { days, ...restOfProRate },
    ...updated_rental_info
  } = rental_info;
  const { total_amount } = charges;
  updated_rental_info.move_in_date = MoveInDate;
  updated_rental_info.prorate = restOfProRate;
  updated_rental_info.promo_plan_ids = promoPlanData?.promo_plan_ids;
  return source === 'Move_In'
    ? {
        move_in: {
          unit_type_id: unit_type_id,
          rental_info: updated_rental_info,
          reservation_id: reservationId,
        },
        total_amount,
        ledgerIdFromSMS,
      }
    : {
        reserve: {
          reservation_date: getMoveInDateForMoveInForm(new Date()),
          unit_type_id: unit_type_id,
          rental_info: updated_rental_info,
        },
        total_amount,
        ledgerIdFromSMS,
      };
};

export const getMoveInDateForMoveInForm = (date: Date) => {
  const moveInFormDate = date
    .toISOString()
    .split('T')[0]
    .split('-');
  return `${moveInFormDate[0]}-${moveInFormDate[1]}-${moveInFormDate[2]}`;
};

export const frameRequestForRentalInfo = async (
  moveInDate: string,
  ledgerId: string,
  unitTypeId: string | number,
  gatsbyPathName: string,
  promoPlanData: any
) => {
  try {
    const source = gatsbyPathName.includes('move-in')
      ? 'Move_In'
      : 'Reservation';
    let framedReq = {};
    const MoveInDate = moveInDate
      ? moveInDate
      : getMoveInDateForMoveInForm(new Date());
    if (ledgerId || ledgerId !== '') {
      framedReq = {
        unit_type_id: unitTypeId,
        ledger_id: ledgerId,
        source,
        rental_info: {
          move_in_date: MoveInDate,
          period: 'Month',
          ...promoPlanData,
        },
      };
    } else {
      framedReq = {
        unit_type_id: unitTypeId,
        source,
        rental_info: {
          move_in_date: MoveInDate,
          period: 'Month',
          ...promoPlanData,
        },
      };
    }
    return framedReq;
  } catch (err) {
    console.error(
      'Error in frameRequestForRentalInfo of confirmation section',
      err
    );
  }
};
